
import bonfire from "../assets/events/BonfireSocial.png";
import game from "../assets/events/JackboxGameNight.png";
import gbm1 from "../assets/events/GBM12025.png";
import gbm2 from "../assets/events/GBM22025.png";
import gbm3 from "../assets/events/GBM32025.png";
import gbm4 from "../assets/events/GBM42025.png";
import gbm5 from "../assets/events/GBM52025.png";
import gbm6 from "../assets/events/GBM62025.png";
import gbm7 from "../assets/events/GBM72025.png";
import gbm8 from "../assets/events/GBM82025.png";
import gbm9 from "../assets/events/GBM9.png";
import gbm10 from "../assets/events/GBM10.png";
import gbm11 from "../assets/events/GBM11.png";
import holiday from "../assets/events/HolidaySocial.png";
import reveal from "../assets/events/MentorReveal.png";
import mixer from "../assets/events/MocktailMixer.png";
import prog1 from "../assets/events/Programming12025.png";
import prog2 from "../assets/events/Programming22025.png";
import prog3 from "../assets/events/Programming32025.png";
import prog4 from "../assets/events/Programming42025.png";
import prog5 from "../assets/events/Programming52025.png";
import downtown from "../assets/events/ProjectDowntown.png";
import pumpkin from "../assets/events/HalloweenSocial.png";
import repurpose from "../assets/events/RepurposeProject.png";
import scavenger2 from "../assets/events/ScavengerHunt2.png";
import scavenger1 from "../assets/events/ScavengerHunt.png";
import speeddating from "../assets/events/SpeedDating.png";
import study from "../assets/events/StudySocial.png";
import showcase from "../assets/events/SuccessShowcase.png";
import thanksgiving from "../assets/events/ThanksgivingPotluck.png";
import winterformal from "../assets/events/WinterFormal.png";
import lakealice from "../assets/events/LakeAliceSocial.png";
import wip from "../assets/events/WIP.png";
import mafia from "../assets/events/MafiaSocial.png"
import chipotle from "../assets/events/ChipotleSocial.png"
import arts from "../assets/events/ArtsNCraftsNightSocial.png"
import arcade from "../assets/events/DaveNBustersSocial.png"
import grace from "../assets/events/GRACEMarketplace.png"
import retreat from "../assets/events/CohortRetreat.png"
import karaoke from "../assets/events/KaraokeNight.png"

const events = [
  {
    name: "Cohort Retreat",
    info: "Fri, Sep 11, 2026",
    desc:
      "",
    image: retreat,
  },
  {
    name: "GBM #1",
    info: "Tue, Sep 15, 2026",
    desc:
      "",
    image: gbm1,
  },
  {
    name: "Scavenger Hunt",
    info: "Thu, Sep 17, 2026",
    desc:
      "",
    image: scavenger2,
  },
  {
    name: "Mentorship Speed Dating",
    info: "Fri, Sep 18, 2026",
    desc:
      "",
    image: speeddating,
  },
  {
    name: "GBM #2",
    info: "Tue, Sep 22, 2026",
    desc:
      "",
    image: gbm2,
  },
  {
    name: "Programming #1",
    info: "Wed, Sep 23, 2026",
    desc:
      "",
    image: prog1,
  },
    {
    name: "Mentorship Mixer",
    info: "Fri, Sep 25, 2026",
    desc:
      "",
    image: mixer,
  },
  /*
  {
    name: "Jackbox Game Night",
    info: "Sun, Sep 28, 2025",
    desc:
      "",
    image: game,
  }
    */,
  {
    name: "GBM #3",
    info: "Tue, Sep 30, 2026",
    desc:
      "",
    image: gbm3,
  },
/*
  {

    name: "Chipotle Social",
    info: "Wed, Oct 1, 2025",
    desc:
      "",
    image: chipotle,
  }
*/,
  {
    name: "Dave & Buster's Social",
    info: "Fri, Oct 2, 2026",
    desc:
      "",
    image: arcade,
  },
  {
    name: "GBM #4",
    info: "Tue, Oct 6, 2026",
    desc:
      "",
    image: gbm4,
  },
  {
    name: "Programming #2",
    info: "Wed, Oct 7, 2026",
    desc:
      "",
    image: prog2,
  }, /*
  {
    name: "GRACE Marketplace Service Event",
    info: "Sat, Oct 11, 2025",
    desc:
      "",
    image: grace,
  } */,
  {
    name: "Mentor Reveal",
    info: "Sun, Oct 11, 2026",
    desc:
      "",
    image: reveal,
  },
  {
    name: "GBM #5",
    info: "Tue, Oct 13, 2026",
    desc:
      "",
    image: gbm5,
  }, /*
  {
    name: "Mafia Social",
    info: "Wed, Oct 15, 2025",
    desc:
      "",
    image: mafia,
  } ,
  {
    name: "Arts and Crafts Night",
    info: "Sun, Oct 19, 2025",
    desc:
      "",
    image: arts,
  } */,
  {
    name: "GBM #6",
    info: "Tue, Oct 20, 2026",
    desc:
      "",
    image: gbm6,
  },
  {
    name: "Progamming #3",
    info: "Thu, Oct 22, 2026",
    desc:
      "",
    image: prog3,
  },
  {
    name: "Halloween Social",
    info: "Wed, Oct 28, 2026",
    desc:
      "",
    image: pumpkin,
  },
  {
    name: "GBM #7",
    info: "Tue, Oct 27, 2026",
    desc:
      "",
    image: gbm7,
  },
  {
    name: "GBM #8",
    info: "Tue, Nov 3, 2026",
    desc:
      "",
    image: gbm8,
  },
   /* {
    name: "Karaoke Night",
    info: "Wed, Nov 4, 2025",
    desc:
      "",
    image: karaoke,
  } */,
  {
    name: "Programming #4",
    info: "Wed, Oct 28, 2026",
    desc:
      "",
    image: prog4,
  },
  {
    name: "First Gen Success Showcae",
    info: "Fri, Nov 6, 2026",
    desc:
      "",
    image: showcase,
  }, /*
{
    name: "Thanksgiving Potluck",
    info: "Thu, Nov 19, 2026",
    desc:
      "",
    image: thanksgiving,
  },
  {
    name: "Winter Formal",
    info: "Sun, Nov 16, 2025",
    desc:
      "",
    image: winterformal,
  } */,
  {
    name: "GBM #9",
    info: "Tue, Nov 10, 2026",
    desc:
      "",
    image: gbm9,
  },
  {
    name: "Programming #5",
    info: "Wed, Nov 18, 2026",
    desc:
      "",
    image: prog5,
  },
  {
    name: "GBM #10",
    info: "Tue, Dec 1, 2026",
    desc:
      "",
    image: gbm10,
  }, /*
  {
    name: "Holiday Extravaganza",
    info: "Thu, Dec 4, 2024",
    desc:
      "",
    image: holiday,
  } */ ,
];

export default events;